import { useSelector } from 'react-redux';

export default function BlurredText({ children }) {
    const { brokenDisplay } = useSelector(state => state.general);
    return <span className={brokenDisplay ? 'blurred2' : ''}>{children}</span>;
}
